import { useEffect, useContext } from 'react';

import { Container, Fade } from '@mui/material';
import { useTranslation } from 'react-i18next';

import CalendarView from './components/CalendarView';
import GridView from './components/GridView';
import Header from './components/Header';
import ListView from './components/ListView';
import { CONTENT_VIEW } from './constants/content';
import { useApp, AppContext } from './context';
import useTitle from './services/useTitle';

import type { CalendarView as CalendarViewType } from 'interfaces/ICalendar';

const App = ({ contentView }: { contentView: CalendarViewType }) => {
    const { i18n } = useTranslation();
    const { translations } = useApp();
    const { setLanguage } = useContext(AppContext);
    // Set head title from calendar translations
    const newTitle = translations.find(
        (translation) => translation.language.toLowerCase() === i18n.language
    )?.html_title;
    useTitle(typeof newTitle === 'string' && newTitle !== '' ? newTitle : document.title);

    useEffect(() => {
        const handle = (e: any) => {
            i18n.changeLanguage(e.target.lang);
            document.documentElement.lang = e.target.lang;
            setLanguage(e.target.lang);
        };
        const changeLanguageButtons = document
            .getElementById('change-language')
            ?.getElementsByClassName('language-button');
        const changeLanguageMobileButtons = document
            .getElementById('languageMenu')
            ?.getElementsByClassName('dropdown-item');

        // Desktop
        if (changeLanguageButtons) {
            Array.prototype.forEach.call(changeLanguageButtons, (button) => {
                button.addEventListener('click', handle);
            });
        }
        // Mobile
        if (changeLanguageMobileButtons) {
            Array.prototype.forEach.call(changeLanguageMobileButtons, (button) => {
                button.addEventListener('click', handle);
            });
        }

        return () => {
            if (changeLanguageButtons) {
                Array.prototype.forEach.call(changeLanguageButtons, (button) => {
                    button.removeEventListener('click', handle);
                });
            }
            if (changeLanguageMobileButtons) {
                Array.prototype.forEach.call(changeLanguageMobileButtons, (button) => {
                    button.removeEventListener('click', handle);
                });
            }
        };
    }, []);

    return (
        <Container>
            <Fade in>
                <div>
                    <Header />
                </div>
            </Fade>
            <Fade in>
                <div>
                    {contentView === CONTENT_VIEW.List ? (
                        <ListView />
                    ) : contentView === CONTENT_VIEW.Grid ? (
                        <GridView />
                    ) : contentView === CONTENT_VIEW.Calendar ? (
                        <CalendarView />
                    ) : null}
                </div>
            </Fade>
        </Container>
    );
};

export default App;
